import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';
import { SUBSCRIPTIONS_URL } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.constants';
import { WorkspaceSuperAppService } from 'reactApp/services';
import opener from 'reactApp/utils/opener';

interface openPageProps {
    inSameTab?: boolean;
    anchor?: string;
    query?: string;
}

export const openSubscriptionsPage = ({ inSameTab = false, anchor = '', query = '' }: openPageProps = {}) => {
    opener(`${SUBSCRIPTIONS_URL}${query ? `?${query}` : ''}${anchor ? `#${anchor}` : ''}`, inSameTab);
};

export const openLink = async (link: string, target = '_self') => {
    const isWorkspaceSuperAppMode = WorkspaceSuperAppService.isEnabled;
    // нужен такой костыль чтобы открыть один iframe из другого iframe
    if (isWorkspaceSuperAppMode) {
        const elementA = document.createElement('a');
        elementA.href = link;
        elementA.target = target;
        elementA.rel = 'noopener noreferrer';
        elementA.click();
    } else if (!IS_MY_TEAM) {
        window.open(link, target);
    } else {
        try {
            import('reactApp/modules/vkTeam/vkTeam.module').then((module) => {
                module.vkTeamsBridge.send('OpenLink', { url: link }).catch((error) => {
                    console.error(error);
                });
            });
        } catch (error) {
            console.error(error);
        }
    }
};
